import { MetaService } from 'app/services/meta.service';
import { LoaderService } from './../../services/loader.service';
import { ConfigService } from 'app/services/config.service';
import { ThemeIconService } from 'app/services/theme-icon.service';
import { PageService } from 'app/services/page.service';
import {
  AfterViewInit,
  Component,
  OnChanges,
  OnInit,
  SimpleChanges,
  ElementRef,
  ViewChild,
  Renderer2,
  HostListener,
  afterRender,
  Input,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
// import { isScullyRunning } from '@scullyio/ng-lib';
declare let APIMaticDevPortal: any;

@Component({
    selector: 'app-api-embed',
    templateUrl: './api-specification-embed.component.html',
    styleUrls: ['./api-specification-embed.component.scss'],
    standalone: false
})
export class ApiSpecificationEmbedComponent implements AfterViewInit {
  tryItButtons;
  authLabelText = 'If you want to generate a key and try out the API, please create a free account and login.';
  previousRouteSusbription = 0;
  hasContent = true;
  getapikeyInfoModal = false;
  sub: any;
  // family: string;
  // api: string;
  apiMaticScriptElement: HTMLScriptElement;
  portalScriptElement: HTMLScriptElement;
  walkthroughScriptElement: HTMLScriptElement;
  apiMaticElement: HTMLElement;
  headerHeight;
  footerHeight;
  @Input() family;
  @Input() api;
  @Input() apiItem;
  @Input() version;
  @ViewChild('parent') parent: ElementRef;
  constructor(
    public loaderService: LoaderService,
    public metaService: MetaService,
    private themeIconService: ThemeIconService,
    private elementRef: ElementRef,
    private pageService: PageService,
    private _renderer: Renderer2,
  ) {
    const ref = afterRender(() => {
      if (window.innerWidth <= 990) {
        this.getHeight('header');
        if (this.headerHeight) {
          this.setHeight('header');
          ref.destroy();
        }
      } else {
        this.getHeight('headerfooter');
        if (this.headerHeight && this.footerHeight) {
          this.setHeight('headerfooter');
          ref.destroy();
        }
      }
    });
  }

  private setPortal(apiItem) {
    const currentTimeStamp = Date.now();
    const currentTheme = this.themeIconService.getDefaultSetting();
    this.apiMaticElement = this.parent.nativeElement.querySelector('#apimatic-widget');
    this.apiMaticScriptElement = this._renderer.createElement('script');
    this.apiMaticScriptElement.src = `assets/matic/portal-script/js/portal.v7-uber.js?ngsw-bypass=${currentTimeStamp}`;
    this.apiMaticScriptElement.defer = true;
    this.apiMaticScriptElement.onload = () => {
      const currentTimeStamp = Date.now();
      this.portalScriptElement = this._renderer.createElement('script');
      this.portalScriptElement.src = this.family
        ? `assets/matic/${this.family}/${this.api}/${this.version}/static/js/portal.js?ngsw-bypass=${currentTimeStamp}`
        : `assets/matic/${this.api}/${this.version}/static/js/portal.js?ngsw-bypass=${currentTimeStamp}`
      this._renderer.appendChild(this.parent.nativeElement, this.portalScriptElement);
      this.portalScriptElement.onload = () => {
        if (APIMaticDevPortal && APIMaticDevPortal.setThemeMode) {
          APIMaticDevPortal.setThemeMode(currentTheme);
        }
        if (apiItem['walkthrough']) {
          const currentTimeStamp = Date.now();
          this.walkthroughScriptElement = this._renderer.createElement('script');
          this.walkthroughScriptElement.src = this.family
            ? `assets/matic/${this.family}/${this.api}/${this.version}/static/walkthroughs/walkthrough.js?ngsw-bypass=${currentTimeStamp}`
            : `assets/matic/${this.api}/${this.version}/static/walkthroughs/walkthrough.js?ngsw-bypass=${currentTimeStamp}`
          this.walkthroughScriptElement.defer = true;
          this._renderer.appendChild(this.parent.nativeElement, this.walkthroughScriptElement);
        }
        this.loaderService.loadingContent.emit(false);
      };
      this.loaderService.loadingContent.emit(false);
    };
    this._renderer.appendChild(this.parent.nativeElement, this.apiMaticScriptElement);
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (window.innerWidth > 990) {
      this.getHeight('headerfooter');
      this.setHeight('headerfooter');
    } else {
      this.getHeight('header');
      this.setHeight('header');
    }
  }

  private getHeight(heightFor: string) {
    if (heightFor === 'header') {
      const headerElement = document.querySelector('app-global-header');
      if (headerElement && headerElement.clientHeight) {
        this.headerHeight = headerElement.clientHeight;
      }
    } else {
      const headerElement = document.querySelector('app-global-header');
      if (headerElement && headerElement.clientHeight) {
        this.headerHeight = headerElement.clientHeight;
      }
      const footerElement = document.querySelector('.footer');
      if (footerElement && footerElement.clientHeight) {
        this.footerHeight = footerElement.clientHeight;
      }
    }
  }

  private setHeight(heightFor: string) {
    const apimaticElement = document.querySelector('.-apimatic-container');
    if (heightFor === 'header') {
      const headerFooterElementHeight = this.headerHeight;
      apimaticElement.setAttribute('style', `height: calc(99.8vh - ${headerFooterElementHeight}px)`);
    } else {
      const headerFooterElementHeight = this.headerHeight + this.footerHeight;
      apimaticElement.setAttribute('style', `height: calc(99.8vh - ${headerFooterElementHeight}px)`);
    }
  }

  ngAfterViewInit(): void {
    this.setPortal(this.apiItem);
  }

  ngOnDestroy(): void {
    this.apiMaticScriptElement.remove();
    if (this.portalScriptElement) {
      this.portalScriptElement.remove();
    }
    if (this.walkthroughScriptElement) {
      this.walkthroughScriptElement.remove();
    }
    if (this.apiMaticElement) {
      this.apiMaticElement.innerHTML = '';
    }
  }
}
